import React from "react";
import { useTranslation } from 'react-i18next';
import AnimateOnView from './AnimateOnView';


export default function TechStack() {
    const { t } = useTranslation();
    const techStack = [
        {
            img: "1.svg",
            skillDes: "js",

        },
        {
            img: "2.svg",
            skillDes: "html"
        },
        {
            img: "3.svg",
            skillDes: "css"
        },
        {
            img: "4.svg",
            skillDes: "scss"
        },
        {
            img: "5.svg",
            skillDes: "bt"
        },
        {
            img: "18.png",
            skillDes: "fg"
        },
        {
            img: "8.svg",
            skillDes: "react"
        },
        {
            img: "9.svg",
            skillDes: "angular"
        },
        {
            img: "10.svg",
            skillDes: "ionic"
        },
        {
            img: "12.svg",
            skillDes: "wordpress"
        },
        {
            img: "17.png",
            skillDes: "git"
        },
        {
            img: "16.png",
            skillDes: "uxui"
        },
        {
            img: "18.svg",
            skillDes: "uxui"
        }
    ]
    return (
        <section className="container portfolio-section" id="tecnologias">
                <h2 className="portfolio-section__title col-12 col-lg-6">
                    {t('ttlTechSkills')}
                    <span></span>
                </h2>

                <p className="portfolio-section__text col-12 col-md-8 text-center mx-auto"> {t('descriptionsTech')}</p>

                <div className="row mt-4">
                    {/* <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/1.svg" alt="Javascript" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('js')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/2.svg" alt="HTML5: Semántico optimizado para SEO" className="skill-cardimage" /></div>
                                <p className="skill-card__description">  {t('html')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/3.svg" alt="CSS3: Flexbox, CSS Grid, UI Responsivo" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('css')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/4.svg" alt="SASS: Preprocesadores CSS" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('scss')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/5.svg" alt="Frameworks CSS: Bootstrap, Angular Material, Material UI, Tailwind CSS" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('bt')}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/18.png" alt="Software UI Desing: Adobe XD, Sketch, Figma" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('fg')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/8.svg" alt="React, MUI" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('react')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/9.svg" alt="Angular, Angular Material" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('angular')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/10.svg" alt="Ionic: apps híbridas" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('ionic')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/12.svg" alt="Wordpress: Modificación del theme" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('wordpress')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/17.png" alt="Github / BitBucket: Controladores de versiones" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('git')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="skill-card">
                            <div className="skill-card__content d-flex">
                                <div className="skill-card__image-container"><img src="img/tech_icons/16.png" alt="ux/ui" className="skill-cardimage" /></div>
                                <p className="skill-card__description"> {t('uxui')}</p>
                            </div>
                        </div>
                    </div> */}

                    {
                        techStack.map((item, idx) => {
                            const cols = 3
                            const perRowIndex = idx % cols
                            const delay = perRowIndex * 0.08

                            return (
                                <AnimateOnView
                                    key={`${item.img}-${item.skillDes}`}
                                    className="col-12 col-md-6 col-lg-4"
                                    variants={{
                                        hidden: { opacity: 0, y: 24 },
                                        visible: { opacity: 1, y: 0 }
                                    }}
                                    delay={delay}
                                >
                                    <div className="skill-card-round">
                                        <div className="skill-card-round__img-container">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/img/tech_icons/${item.img}`}
                                                alt="Logo tech tool"
                                            />
                                        </div>
                                        <div className="card skill-card-round__description">
                                            <div className="bg-card"></div>
                                            <p className="mb-0">   {t(`${item.skillDes}`)}</p>
                                        </div>
                                    </div>
                                </AnimateOnView>
                            )
                        })
                    }


                </div>
        </section>

    )
};